export class NovaTarefa {
  descricao: string;
  valor: number;
  tipoTarefaId: number;
  dataPrevisaoFinalizacao: Date;
  dataInicial: Date;
  dataFinalizacao: Date;
  atendimentoId: number | null = null;
  descricaoDetalhada: string;
}
